import React from 'react';
import { createUseStyles } from 'react-jss';

interface TabProps {
  activeTabId: string;
  sets: {
    id: string;
    title: string;
    content: React.ReactNode;
    onTitleClick?: () => void;
  }[];
}

const useStyles = createUseStyles({
  tabContainer: {
    width: '100%',
  },
  tabHeader: {
    display: 'flex',
    marginBottom: '20px',
  },
  tabTitle: {
    flex: 1,
    textAlign: 'center',
    padding: '0 15px 15px',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'all 0.2s',
    position: 'relative',
    borderBottom: '1px solid #ebebeb',
    '&:hover': {
      color: 'var(--dai-primary-color)',
    },
    '&.active': {
      color: 'var(--dai-primary-color)',
      borderBottom: '1px solid var(--dai-primary-color)',
      '&:after': {
        content: '""',
        position: 'absolute',
        bottom: '0',
        left: '0',
        width: '100%',
        height: '1px',
        backgroundColor: 'var(--dai-primary-color)',
      },
    },
  },
  tabContent: {
    padding: '0',
  },
});

const Tab: React.FC<TabProps> = ({ activeTabId, sets }) => {
  const classes = useStyles();

  return (
    <div className={classes.tabContainer}>
      <div className={classes.tabHeader}>
        {sets.map((set, index) => (
          <div
            key={index}
            className={`${classes.tabTitle} ${
              activeTabId === set.id ? 'active' : ''
            }`}
            onClick={() => {
              set.onTitleClick?.();
            }}
          >
            {set.title}
          </div>
        ))}
      </div>

      <div className={classes.tabContent}>
        {sets.find((set) => set.id === activeTabId)?.content}
      </div>
    </div>
  );
};

export default Tab;
